import React from 'react';

/**
 * Telemetry primitives for project / protocol / tool cards.
 * Pure CSS, no motion dependency here so they can be nested freely.
 */

export function StatusPill({ status = 'active', label }) {
  const colorMap = {
    active:   { dot: '#00F0FF', text: 'text-cyan-300',  border: 'border-cyan-400/40' },
    verified: { dot: '#34D399', text: 'text-emerald-300', border: 'border-emerald-400/40' },
    warn:     { dot: '#FFB800', text: 'text-amber-300',  border: 'border-amber-400/40' },
  };
  const c = colorMap[status] || colorMap.active;
  return (
    <span
      className={`inline-flex items-center gap-1.5 font-mono text-[9px] tracking-[0.22em] uppercase px-2 py-0.5 border ${c.border} ${c.text} bg-black/25`}
      data-testid={`status-pill-${status}`}
    >
      <span
        className="w-1.5 h-1.5 rounded-full animate-pulse shrink-0"
        style={{ background: c.dot, boxShadow: `0 0 6px ${c.dot}` }}
      />
      {label || `status: ${status}`}
    </span>
  );
}

export function TelemetryRow({ label, value, accent = false }) {
  return (
    <div className="flex items-center justify-between font-mono text-[10px] tracking-[0.18em] uppercase">
      <span className="text-white/35">{label}</span>
      <span className={accent ? 'text-[var(--warning-amber)]' : 'text-white/70'}>
        {value}
      </span>
    </div>
  );
}

export function DeploymentBadge({ verified = true, children }) {
  return (
    <span
      className="inline-flex items-center gap-2 font-mono text-[9px] tracking-[0.24em] uppercase text-white/55"
      data-testid="deployment-badge"
    >
      <span
        className="w-3 h-3 flex items-center justify-center rounded-[2px] border"
        style={{
          borderColor: verified ? '#34D399' : '#FFB800',
          color: verified ? '#34D399' : '#FFB800',
          fontSize: 8,
          lineHeight: 1,
        }}
      >
        {verified ? '✓' : '!'}
      </span>
      {children || (verified ? 'deployment: verified' : 'deployment: pending')}
    </span>
  );
}
